import {
  ActivityIcon,
  ClipboardListIcon,
  DumbbellIcon,
  type LucideIcon,
  SlidersHorizontalIcon,
  UserIcon,
  UsersIcon,
} from 'lucide-react';

export type NavItem = {
  label: string;
  /** Absent while the screen has no design yet: rendered as a disabled item. */
  to?: string;
  icon: LucideIcon;
};

/** The two nav groups of the coach shell, in prototype order. */
export const NAV_GROUPS: [NavItem, ...NavItem[]][] = [
  [
    { label: 'Overview', icon: ActivityIcon },
    { label: 'Clients', to: '/clients', icon: UserIcon },
    { label: 'Programs', icon: ClipboardListIcon },
    { label: 'Exercises', icon: DumbbellIcon },
    { label: 'Communities', to: '/communities', icon: UsersIcon },
  ],
  [{ label: 'Settings', to: '/settings', icon: SlidersHorizontalIcon }],
];
